import { z } from "zod";
import { ShortText, MediumText, Tone, idString } from "./common.js";
const CurrentStateStat = z
    .object({
    id: idString,
    label: ShortText,
    value: ShortText,
    delta: MediumText.optional(),
    tone: Tone.optional(),
})
    .strict();
/**
 * Current-State Snapshot — Oppress, singleton. Baseline metrics shown in
 * a 3-column tile grid. Each tile carries an optional delta + tone for
 * RAG-style colouring.
 */
export const CurrentStateStatsParamsSchema = z
    .object({
    stats: z.array(CurrentStateStat).max(50),
})
    .strict();
export const defaultCurrentStateStatsParams = {
    stats: [],
};
//# sourceMappingURL=currentStateStats.js.map